import { useDispatch } from 'react-redux';
import {
  saveSnapshot,
  updateTextContentItemContent
} from '@src/actions/wysiwyg/editor';
import { TTextBoxContentItem } from '@src/types/wysiwyg_editor';
import { TPositionableTextDocument } from '@src/lib/PositionableTextDocument';

export default function useSetTextBoxContent(): (
  item: TTextBoxContentItem,
  positionedDocument: TPositionableTextDocument,
  save: boolean
) => void {
  const dispatch = useDispatch();

  return function setImageContent(
    targetPageContentItem,
    positionedDocument,
    save = true
  ) {
    if (save) dispatch(saveSnapshot());
    dispatch(
      updateTextContentItemContent(targetPageContentItem.id, positionedDocument)
    );
  };
}
